import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import ObjectFloat from './objects/ObjectFloat';
import '../styles/Resources.css';
import '../styles/Home.css';

/**
 * Hand-picked lesson teasers, duplicated as literals so the homepage
 * bundle never pulls in the full (lazy-loaded) curriculum data. Keep
 * codes/titles in sync with src/data/resources.ts if lessons move.
 */
const FEATURED = [
  {
    slug: 'trade-idea-generation',
    code: '1.1',
    track: 'S&T',
    title: 'Trade idea generation',
    line: 'Produce a trade idea with a catalyst and an edge, not just an opinion.'
  },
  {
    slug: 'paper-lbo',
    code: '3.2',
    track: 'IB',
    title: 'The paper LBO walkthrough',
    line: 'Run the classic 5-minute paper LBO out loud, with no calculator.'
  },
  {
    slug: 'market-sizing',
    code: '2.1',
    track: 'Consulting',
    title: 'Market sizing',
    line: 'Size any market with a defensible structure and clean numbers.'
  }
];

const ResourceTeaser: React.FC = () => {
  return (
    <section className="section section-alt teaser">
      <div className="obj-spot spot-stack" aria-hidden="true"><ObjectFloat slug="stack" /></div>
      <div className="container">
        <div className="section-head" data-reveal>
          <p className="section-eyebrow">Resource pack</p>
        </div>

        <div className="resource-list teaser-list">
          {FEATURED.map((lesson, index) => (
            <Link
              key={lesson.slug}
              to={`/resources/${lesson.slug}`}
              className="resource-row bracketed"
              data-reveal
              style={{ ['--reveal-delay' as string]: `${index * 0.06}s` }}
            >
              <span className="code-chip">{lesson.code}</span>
              <span className="resource-row-body">
                <span className="resource-row-title">{lesson.title}</span>
                <span className="resource-row-summary">{lesson.line}</span>
              </span>
              <span className="resource-row-meta">
                {lesson.track}
                <ArrowRight size={15} aria-hidden="true" />
              </span>
            </Link>
          ))}
        </div>

        <div className="teaser-cta" data-reveal>
          <Link className="btn btn-primary" to="/resources">
            Browse
            <ArrowRight size={16} aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ResourceTeaser;
